import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Sostenibilita({ idVariant = '', className }: Props) {
  return (
    <IconBase name="sostenibilita" w={65} className={className}>
      <path
        d="M11.93 44.92C12.13 45.73 12.19 45.99 12.17 46.18V46.26L12.13 46.33C10.75 49.28 9.57001 52.53 8.62001 55.99C8.52001 56.37 8.57001 56.72 8.78001 57C9.01001 57.31 9.42001 57.5 9.84001 57.5C10.1 57.5 10.73 57.41 10.94 56.63C11.79 53.52 12.85 50.58 14.07 47.9L14.21 47.6L14.54 47.63C15.87 47.77 17.19 47.87 18.45 47.93L21.73 47.99H21.75C30.05 47.88 36.24 45.77 40.69 41.54L43.6 38.15C46.57 33.94 48.22 28.89 49.81 24C50.45 22.03 51.11 20 51.85 18.06L53.32 14.63C53.41 14.46 55.05 11.47 56.13 10.17C56.43 9.82 56.52 9.35 56.36 8.92C56.2 8.5 55.86 8.23 55.41 8.16C52.33 7.72 49.21 7.5 46.16 7.5C34.23 7.5 24.22 10.88 17.96 17.01C11.1 23.73 9.07001 33.12 11.93 44.91V44.92ZM46.18 9.91C48.18 9.91 50.23 10.01 52.27 10.21L53.01 10.28L52.61 10.91C50.4 14.41 49.05 18.54 47.62 22.91C44.16 33.53 40.24 45.54 20.7 45.54C19.23 45.54 17.66 45.47 16.05 45.34L15.34 45.28L15.68 44.66C20.11 36.64 24.82 33.26 28.97 30.29C29.8 29.69 30.59 29.13 31.36 28.54C31.95 28.09 31.87 27.55 31.78 27.26C31.6 26.73 31.11 26.35 30.62 26.35C30.38 26.35 30.13 26.44 29.9 26.62C29.11 27.23 28.31 27.8 27.47 28.41C23.47 31.29 18.94 34.56 14.48 41.95L13.85 42.98L13.63 41.79C12.04 33.09 13.55 25.89 18.13 20.39C23.69 13.72 33.91 9.9 46.17 9.9L46.18 9.91Z"
        fill="currentColor"
      />
    </IconBase>
  )
}

export default Sostenibilita
